import * as React from 'react';
import './logo-text.scss';

const LogoText = () => (
  <span className="obi2b-logo">Obi<span className="obi2b-logo-grey">2b</span></span>
);

export default LogoText;

